
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 120 37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M52.488 20.326h7.268l-3.843-6.199-7.054 11.207h-3.21l8.58-13.462A2.026 2.026 0 0155.913 11c.667 0 1.289.317 1.65.85l8.614 13.484h-3.21l-1.515-2.504h-7.359l-1.605-2.504zm33.347 2.504V11.136h-2.724v12.838c0 .352.135.692.395.952s.61.408.995.408h12.424l1.605-2.504H85.835zm-45.07-2.097a4.792 4.792 0 004.793-4.793 4.801 4.801 0 00-4.793-4.804H28.847v14.198h2.724V13.64h9.014a2.29 2.29 0 012.283 2.3 2.29 2.29 0 01-2.283 2.3l-7.68-.01 8.132 7.104h3.956l-5.471-4.6h1.244zm-28.682 4.601C8.173 25.334 5 22.161 5 18.241c0-3.921 3.173-7.105 7.083-7.105h8.233c3.911 0 7.082 3.184 7.082 7.105 0 3.92-3.17 7.093-7.082 7.093h-8.233zm8.05-2.504a4.584 4.584 0 004.585-4.59c0-2.537-2.052-4.6-4.585-4.6h-7.867c-2.533 0-4.586 2.063-4.586 4.6a4.585 4.585 0 004.585 4.59h7.868zm51.73 2.504a7.09 7.09 0 01-7.088-7.093c0-3.921 3.177-7.105 7.088-7.105h9.779l-1.594 2.504h-8.004a4.598 4.598 0 00-4.59 4.6 4.589 4.589 0 004.59 4.59h9.823l-1.605 2.504h-8.399zm33.314-2.504a4.58 4.58 0 01-4.409-3.343h11.644l1.605-2.504h-13.249a4.594 4.594 0 014.409-3.343h7.992l1.616-2.504h-9.789c-3.911 0-7.088 3.184-7.088 7.104a7.09 7.09 0 007.088 7.094h8.399L115 22.83h-9.823z","fill":"#E6E7E9"}})])
          )
        }
      }
    